export const RANKING_DATA = {
  rankings: [
    {
      rank: 1,
      name: "ShadowBlade99",
      score: 15000,
      color: "bg-purple-600",
      emoji: "⚔️"
    },
    {
      rank: 2,
      name: "DragonMaster",
      score: 14500,
      color: "bg-red-600",
      emoji: "🐲"
    },
    {
      rank: 3,
      name: "pixel_princess",
      score: 14000,
      color: "bg-pink-600",
      emoji: "👑"
    },
    {
      rank: 4,
      name: "CodeNinja42",
      score: 13500,
      color: "bg-green-600",
      emoji: "🥷"
    },
    {
      rank: 5,
      name: "BabyYodaFan",
      score: 13000,
      color: "bg-emerald-600",
      emoji: "👶"
    },
    {
      rank: 6,
      name: "Pr0_G4mer",
      score: 12500,
      color: "bg-blue-600",
      emoji: "🎮"
    },
    {
      rank: 7,
      name: "DancingPotato",
      score: 12000,
      color: "bg-yellow-600",
      emoji: "🥔"
    },
    {
      rank: 8,
      name: "cosmic_wanderer",
      score: 11500,
      color: "bg-indigo-600",
      emoji: "🌌"
    },
    {
      rank: 9,
      name: "Mike_1995",
      score: 11000,
      color: "bg-orange-600",
      emoji: "😎"
    },
    {
      rank: 10,
      name: "PowerPlayer",
      score: 10500,
      color: "bg-cyan-600",
      emoji: "💪"
    }
  ],
  playerRank: {
    rank: 156,
    score: 5430
  },
  nearbyPlayers: [
    {
      rank: 151,
      name: "CoffeeWarrior",
      score: 5680,
      color: "bg-amber-600",
      emoji: "☕"
    },
    {
      rank: 152,
      name: "StardustKnight",
      score: 5640,
      color: "bg-violet-600",
      emoji: "⭐"
    },
    {
      rank: 153,
      name: "pixelated_dreams",
      score: 5590,
      color: "bg-rose-600",
      emoji: "🎨"
    },
    {
      rank: 154,
      name: "RocketQueen",
      score: 5550,
      color: "bg-teal-600",
      emoji: "🚀"
    },
    {
      rank: 155,
      name: "MusicMaster",
      score: 5500,
      color: "bg-lime-600",
      emoji: "🎵"
    },
    {
      rank: 156,
      name: "YOU",
      score: 5430,
      color: "bg-yellow-600",
      emoji: "😎"
    },
    {
      rank: 157,
      name: "WizardOfCode",
      score: 5400,
      color: "bg-blue-600",
      emoji: "🧙"
    },
    {
      rank: 158,
      name: "NightOwl",
      score: 5380,
      color: "bg-indigo-600",
      emoji: "🦉"
    },
    {
      rank: 159,
      name: "CyberPunk2099",
      score: 5350,
      color: "bg-purple-600",
      emoji: "🤖"
    },
    {
      rank: 160,
      name: "rainbow_warrior",
      score: 5320,
      color: "bg-red-600",
      emoji: "🌈"
    }
  ]
};
